module.exports = __webpack_public_path__ + "img/ep4-chat.518eba6e.png";